import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import moment from 'moment';
import pad from 'pad';
import Barcode from 'react-barcode';
import utils from '../../../utils/utils.functions';
import {
  Dropdown
} from 'react-bootstrap';
import {
  faFileAlt,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
 
class ComponentToPrint extends React.Component {

  render() {
    const { guide, prefijo, empresa, currency, showPrefixGuide } = this.props;
    return (
    <div style={{ padding: 10 }}>
       <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          border: "1px solid #ccc",
          padding: 10,
          marginTop: 3
        }}
      >
        <div style={{ textAlign: "left", marginBottom: 3 }}>
           <h3>DETALLE DE GUIA</h3>
           <Barcode value={guide.uuid} height={25} width={1} margin={0} />
        </div>
        <div style={{ textAlign: "right" }}>
            <small style={{ padding: 0 }}>Empresa:</small>
            <div>{empresa.nombre_empresa}</div>
          </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          border: "1px solid #ccc",
          padding: 10,
          marginTop: 3
        }}
      >
        <div>
          <div style={{ textAlign: "left" }}>
            <small style={{ padding: 0 }}>Registrado</small>
            <div>{moment(guide.createdAt).format('DD/MM/YYYY H:m:s')}</div>
          </div>
          <div style={{ textAlign: "left" }}>
            <small style={{ padding: 0 }}>Gui master</small>
            <div>{pad(5,guide.master_guia.id,'0')}</div>
          </div>
          <div style={{ textAlign: "left" }}>
            <small style={{ padding: 0 }}>Guia paquete</small>
            <div>{`${showPrefixGuide ? guide.master_guia.rel_tipos.prefijo : prefijo}-${guide.guia_paquete}`}</div>
          </div>
          <div style={{ textAlign: "left" }}>
            <small style={{ padding: 0 }}>Tipo de envio</small>
            <div>{guide.master_guia.rel_tipos.description}</div>
          </div>
          <div style={{ textAlign: "left" }}>
            <small style={{ padding: 0 }}>Bultos</small>
            <div>{guide.bultos.length}</div>
          </div>
        </div>
        <div>
          <div style={{ textAlign: "right" }}>
            <small style={{ padding: 0 }}>Remitente</small>
            <div>{guide.cliente.name}</div>
          </div>
          <div style={{ textAlign: "right" }}>
            <small style={{ padding: 0 }}>Destinatario</small>
            <div>{guide.cliente_receptor_nombre}</div>
          </div>
          <div style={{ textAlign: "right" }}>
            <small style={{ padding: 0 }}>Identificación</small>
            <div>{guide.cliente_receptor_identificacion}</div>
          </div>
          <div style={{ textAlign: "right" }}>
            <small style={{ padding: 0 }}>Telefono</small>
            <div>{guide.cliente_receptor_telefono}</div>
          </div>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          border: "1px solid #ccc",
          padding: 10,
          marginTop: 3
        }}
      >
        <div style={{ textAlign: "left" }}>
          <small style={{ padding: 0 }}>Direccion de entrega</small>
          <div>{guide.cliente_receptor_direccion_entrega.toUpperCase()} - {guide.estado_guia.estado !== '-' && guide.estado_guia.estado.toUpperCase()} {guide.ciudad_guia.ciudad !== '-' && guide.ciudad_guia.ciudad.toUpperCase()} {guide.pais_guia.country}</div>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          border: "1px solid #ccc",
          padding: 10,
          marginTop: 3
        }}
      >
        <div style={{ textAlign: "left" }}>
          <small style={{ padding: 0 }}>Bultos</small>
          {guide.bultos.map((bulto) => {
           return  <div key={bulto.id} style={{ display: "flex", flexDirection: "column" }}>
              <div>{bulto.alto} * {bulto.ancho} * {bulto.largo} - {bulto.peso} Kg</div>
            </div>
           })
          }
        </div>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          border: "1px solid #ccc",
          padding: 10,
          marginTop: 3
        }}
      >
        <div style={{ textAlign: "left", width: "100%" }}>
          <small style={{ padding: 0 }}>Detalle productos</small>
          {guide.detalle.length ? 
            <div style={{ display: "flex", flexWrap: 'wrap' }}>
              {guide.detalle.map((articulo) => {  
                return  <div key={articulo.id} style={{ fontSize: 11, paddingLeft: 5 }}> 
                  ({articulo.cantidad}) {articulo.descripcion},
                </div>
              })}
            </div>
           :
           <div style={{ width: "100%", textAlign: "center" }}>
             No Aplica
           </div>
           }
        </div>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          border: "1px solid #ccc",
          padding: 10,
          marginTop: 3
        }}
      >
       <div style={{ textAlign: "letf" }}>
       </div>
       <div style={{ textAlign: "letf" }}>
          <small style={{ padding: 0 }}>Total pagado</small>
       <div>{utils.formatMoney(guide.monto_pago)} {currency}</div>
       </div>
      </div>
    </div>
    );
  }
}
 
const PrinterFull = ({ data, prefijo, empresa, currency, disabled, showPrefixGuide }) => {

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  

  return (
    <div>
      <div style={{ display: 'none'}}>
       <ComponentToPrint 
          guide={data}
          empresa={empresa}
          prefijo={prefijo}
          currency={currency}
          ref={componentRef}
          showPrefixGuide={showPrefixGuide}
        />
      </div>
      <Dropdown.Item disabled={disabled} onClick={handlePrint}>
        <FontAwesomeIcon icon={faFileAlt} /> Detalle guia
      </Dropdown.Item>
    </div>
  );
};

export default PrinterFull;